// WebView-safe polyfill: Element.toggleAttribute
if (window.Element && !Element.prototype.toggleAttribute) {
  Element.prototype.toggleAttribute = function (name, force) {
    const shouldSet = force !== undefined ? !!force : !this.hasAttribute(name);
    if (shouldSet) this.setAttribute(name, '');
    else this.removeAttribute(name);
    return shouldSet;
  };
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

const next = summary.nextElementSibling;
if (next && next.getAttribute('id')) {
  summary.setAttribute('aria-controls', next.id);
}


  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.metric_prefix}:${benchmarkName}`;
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.metric_prefix}:${benchmarkName}`;
    performance.mark(`${metricName}:start`, { startTime: event.timeStamp });
    performance.mark(`${metricName}:end`);
    performance.measure(benchmarkName, `${metricName}:start`, `${metricName}:end`);
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.metric_prefix}:${benchmarkName}`;
    performance.mark(`${metricName}:end`);
    performance.measure(benchmarkName, startMarker.name, `${metricName}:end`);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.metric_prefix}:${benchmarkName}`;
    performance.mark(`${metricName}:start`);
    callback();
    performance.mark(`${metricName}:end`);
    performance.measure(benchmarkName, `${metricName}:start`, `${metricName}:end`);
  }
}
CartPerformance.metric_prefix = 'cart-performance';



/* PO2 — MOBILE CART: anchor qty to image center + center TOTAL + move TRASH */
(() => {
  // Skip entirely in the Shopify theme customizer.
  // This IIFE attaches multiple MutationObservers to #CartDrawer which fire on
  // every DOM change — inside the customizer iframe that causes section-add freezes.
  if (window.Shopify && window.Shopify.designMode) return;

  const isMobile = () => window.innerWidth <= 749;
  const imp = (el,k,v)=>el && el.style.setProperty(k,v,'important');

  // === your existing tunables (keep these how you like) ===
  const LEFT_PERCENT = 65;     // coarse horizontal (across row)
  const X_NUDGE_PX   = 18;      // fine horizontal px nudge (increase = right)
  const SCALE        = .95;    // selector scale (1 = full size)
  // ========================================================

  // === TRASH POSITION (tune these) ========================
  // Mode: 'right' puts the trash to the right of the selector; 'below' puts it under the TOTAL
  const TRASH_MODE = 'right';  // 'right' | 'below'
  const TRASH_X    = -330;        // px nudge (positive moves right; negative left)
  const TRASH_Y    = 73;        // px nudge (positive moves down; negative up)
  const TRASH_SIZE = 28;       // click target size (px)
  // ========================================================

 function moveTrash(item, wrap) {
  // Hide any native remove control (keep it in DOM so theme JS still works)
  const original = item.querySelector(
    '.cart-remove, .cart-remove-button, [data-cart-remove], button[name="remove"], a[href*="change?"][href*="quantity=0"], button[aria-label*="Remove"], a[aria-label*="Remove"]'
  );
  if (original) {
    imp(original, 'display', 'none');
    imp(original, 'pointer-events', 'none');
  }
  if (wrap) {
    const holder = wrap.querySelector('.po2-remove');
    if (holder) imp(holder, 'display', 'none');
  }
}
function po2ClickRemove(el) {
  if (!el) return;

  // Prevent double-trigger (this was removing 2 items when line numbers shift)
  if (el.dataset.po2RemoveFired === '1') return;
  el.dataset.po2RemoveFired = '1';

  // One action only
  el.click();

  // Allow future removes after the drawer re-renders
  setTimeout(() => {
    if (el) el.dataset.po2RemoveFired = '0';
  }, 800);
}


function enableZeroToRemove(item) {
  if (item.dataset.po2ZeroRemove === '1') return; // prevent duplicate listeners
  item.dataset.po2ZeroRemove = '1';

  const input = item.querySelector('quantity-input input, .quantity__input, input[name="updates[]"]');
  const minusBtns = item.querySelectorAll(
    'button[name="minus"], .quantity__button[name="minus"], .quantity__button--minus, button[aria-label*="Decrease"], button[aria-label*="Minus"]'
  );
  const remover = item.querySelector(
    '.cart-remove, .cart-remove-button, [data-cart-remove], button[name="remove"], a[href*="change?"][href*="quantity=0"], button[aria-label*="Remove"], a[aria-label*="Remove"]'
  );

  // Typing 0 then blur/change → remove
  if (input && remover) {
    input.addEventListener('change', (e) => {
      const q = parseInt(input.value, 10);
      if (!Number.isFinite(q) || q <= 0) {
        // avoid “minimum 1” validation flash
        input.value = '1';
        e.preventDefault();
        e.stopPropagation();
        po2ClickRemove(remover);
      }
    }, true);
  }

  // Tapping minus when at 1 → remove
  minusBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const current = parseInt((input && input.value) || '1', 10) || 1;
      if (current <= 1 && remover) {
        e.preventDefault();
        e.stopPropagation();
        // keep UI stable, then remove
        if (input) input.value = '1';
        po2ClickRemove(remover);
      }
    }, true); // capture to beat theme’s min-1 handler
  });
}


  function apply(item){
    if (!isMobile()) return;

    // row + media (anchor to image center)
    const row   = item.closest('.cart-item') || item;
    const media = row.querySelector('.cart-item__media img, .cart-item__image') 
               || row.querySelector('.cart-item__media');
    if (!row || !media) return;

    // find the pill (wherever the theme put it)
    const pill = item.querySelector('.cart-item__quantity quantity-input, .cart-item__quantity .quantity, quantity-input.quantity, .quantity');
    if (!pill) return;

    // ensure wrapper
    let wrap = pill.closest('.po2-qty-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'po2-qty-wrap';
      pill.parentNode.insertBefore(wrap, pill);
      wrap.appendChild(pill);
    }
    if (wrap.parentElement !== row) row.appendChild(wrap);

    // row positioning context
    imp(row,'position','relative');

// style + scale pill once
if (!wrap.dataset.styled) {
  const box = wrap.querySelector('.quantity') || pill;
  if (box){
    imp(box,'transform',`scale(${SCALE})`);
imp(box,'transform-origin','center center');
imp(box,'border-radius','9999px');

/* one crisp border, nothing else */
imp(box,'border','1px solid #111');
imp(box,'box-shadow','none');              // kill inset outline
imp(box,'background','#fff');
imp(box,'background-image','none');        // ensure no gradient ring
imp(box,'outline','none');

  }
  wrap.querySelectorAll('.quantity__button, .quantity__input')
    .forEach(b => { imp(b,'border','0'); imp(b,'box-shadow','none'); });
  wrap.dataset.styled = '1';
}


    // anchor to the image vertical center (no drift)
    const rr = row.getBoundingClientRect();
    const mr = media.getBoundingClientRect();
    const anchorY = (mr.top - rr.top) + (mr.height / 2);

    imp(wrap,'position','absolute');
    imp(wrap,'left', `${LEFT_PERCENT}%`);
    imp(wrap,'top',  `${Math.round(anchorY)}px`);
    imp(wrap,'transform', `translate(${X_NUDGE_PX}px, calc(-50% + 20px))`);
    imp(wrap,'display','flex');
    imp(wrap,'flex-direction','column');
    imp(wrap,'align-items','center');
    imp(wrap,'gap','6px');
    imp(wrap,'z-index','3');

    // inline TOTAL under the selector (read from totals cell, then hide that cell)
    let total = wrap.querySelector('.po2-inline-total');
    if (!total) {
      total = document.createElement('div');
      total.className = 'po2-inline-total';
      wrap.appendChild(total);
    }
    imp(total,'position','absolute');
    imp(total,'top','100%'); imp(total,'left','50%');
    imp(total,'transform','translateX(-50%)');
    imp(total,'margin-top','8px'); imp(total,'white-space','nowrap'); imp(total,'font-weight','700');

    const totalsCell = item.querySelector('.cart-item__totals');
    // Prefer totals cell and take the LAST currency (line total);
// fall back to qty × unit price if needed.
const source     = (totalsCell && totalsCell.textContent) ? totalsCell.textContent : '';
let lineTotalStr = null;

// 1) Try totals cell
if (source) {
  const amounts = source.replace(/\s+/g, ' ').match(/\$[0-9][\d,]*(?:\.\d{2})?/g);
  if (amounts && amounts.length) lineTotalStr = amounts[amounts.length - 1];
}

// 2) Fallback: qty × unit price
if (!lineTotalStr) {
  const qtyInput = item.querySelector('quantity-input input, .quantity__input, input[name="updates[]"]');
  const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1
                       : parseInt((pill.textContent || '').replace(/[^\d]/g, ''), 10) || 1;

  const unitMatch = (item.textContent || '').match(/\$[0-9][\d,]*(?:\.\d{2})?/);
  if (unitMatch) {
    const unit = parseFloat(unitMatch[0].replace(/[$,]/g, ''));
    if (!Number.isNaN(unit)) {
      const n = (unit * qty).toFixed(2);
      lineTotalStr = `$${n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    }
  }
}

if (lineTotalStr) {
  total.textContent = `TOTAL: ${lineTotalStr}`;
  if (totalsCell) imp(totalsCell, 'display', 'none'); // hide duplicate only after reading
}


    // neutralize native qty cell on mobile so it won’t fight us
    const nativeQty = item.querySelector('td.cart-item__quantity, td[headers="CartDrawer-ColumnQuantity"]');
    if (nativeQty) {
      imp(nativeQty,'position','static');
      imp(nativeQty,'transform','none');
      imp(nativeQty,'width','auto');
      imp(nativeQty,'display','block');
    }

    // 👉 finally, position/move the trash can
    moveTrash(item, wrap);
    enableZeroToRemove(item);
  }
function toggleUpsellIfEmpty() {
  if (!isMobile()) return;

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const hasItems = !!drawer.querySelector('.cart-item');

  // Empty-state container (Dawn & common variants)
  const empty = drawer.querySelector(
    '#CartDrawer-Empty, .cart-drawer__empty, .drawer__inner-empty, [id*="Empty"]'
  );

  // Footer (estimated total / checkout)
  const footer = drawer.querySelector(
    '.cart-drawer__footer, .drawer__footer, .cart__footer'
  );

  // Upsell / recommendations containers (broad but safe)
  const upsells = new Set([
    ...drawer.querySelectorAll(
      '.product-recommendations, .cart-recommendations, .cart-drawer__recommendations, .complementary-products, ' +
      '[data-section*="recommend"], [id*="recommend"], [class*="recommend"]'
    )
  ]);

  // Also catch a block that has the "Complete the look" heading
  drawer.querySelectorAll('h1,h2,h3,h4').forEach((h) => {
    const t = (h.textContent || '').trim().toLowerCase();
    if (t.includes('complete the look')) {
      const section = h.closest('section, .shopify-section, .product-slider, .grid, div');
      if (section) upsells.add(section);
    }
  });

  if (!hasItems) {
    // Show the empty state
    if (empty) {
      empty.classList.remove('hidden');
      empty.style.removeProperty('display');
      empty.style.removeProperty('height');
      empty.style.removeProperty('margin');
      empty.style.removeProperty('padding');
    }

    // Hide upsells + footer
    upsells.forEach((el) => { if (el) el.style.setProperty('display', 'none', 'important'); });
    if (footer) footer.style.setProperty('display', 'none', 'important');
  } else {
    // Restore when items exist again
    upsells.forEach((el) => { if (el) el.style.removeProperty('display'); });
    if (footer) footer.style.removeProperty('display');
    // Let Dawn control empty visibility when not empty
    if (empty) empty.classList.add('hidden');
  }
}

function hideUpsellArrowsOnMobile() {
  if (!isMobile()) return;

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  // Find the "Complete the look" section (fallback to any recommend block)
  const findSection = () => {
    const heading = Array.from(drawer.querySelectorAll('h1,h2,h3,h4'))
      .find(h => /complete/i.test(h.textContent || '') && /look/i.test(h.textContent || ''));
    if (heading) {
      const sec = heading.closest('section, .shopify-section, [class*="recommend"], .product-recommendations, .cart-drawer__recommendations, div');
      if (sec) return sec;
    }
    return drawer.querySelector('.cart-drawer__recommendations, .product-recommendations, [class*="recommend"]') || null;
  };

  const isArrowish = (el) => {
    const cls   = (el.className || '').toString().toLowerCase();
    const id    = (el.id || '').toLowerCase();
    const role  = (el.getAttribute('role') || '').toLowerCase();
    const lbl   = (el.getAttribute('aria-label') || '').toLowerCase();
    const name  = (el.getAttribute('name') || '').toLowerCase();
    const title = (el.getAttribute('title') || '').toLowerCase();
    const ctrl  = (el.getAttribute('aria-controls') || '').toLowerCase();
    const txt   = (el.textContent || '').trim().toLowerCase();

    // Heuristics that catch slider nav, not product CTAs
    const arrowToken = /(arrow|nav|chevron|caret|slider-button|flickity|splide__arrow|embla__|swiper-button|glide__arrow|keen-slider__|prev|next)/;
    const hasToken   = arrowToken.test(cls) || arrowToken.test(id) || arrowToken.test(role) ||
                       arrowToken.test(lbl) || arrowToken.test(name) || arrowToken.test(title) ||
                       /slider/.test(ctrl) || /(‹|›|«|»)/.test(txt);

    // Avoid anything that looks like an add/select CTA or is inside a product form/card
    const inProductForm = !!el.closest('.product-form, [data-product-form], form');
    const inProductCard = !!el.closest('.product-card, .card, [data-product-id]');
    const looksLikeAdd  = /(add|to cart|buy|select)/.test(txt) || /(add|cart|buy|select)/.test((el.value || '').toLowerCase());

    return hasToken && !looksLikeAdd && !inProductForm && !inProductCard;
  };

  const makeTrackSwipeable = (sec) => {
    sec.querySelectorAll('.slider, [data-slider], .splide__track, .embla__container, .swiper-wrapper, [class*="track"], .grid')
      .forEach(track => {
        track.style.setProperty('overflow-x', 'auto', 'important');
        track.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      });
  };

  const apply = () => {
    const section = findSection();
    if (!section) return;

    // Hide any “arrow-ish” controls only
    section.querySelectorAll('button, a, div, span, svg').forEach(el => {
      if (isArrowish(el)) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('opacity', '0', 'important');
      }
    });

    // Ensure the list can be finger-scrolled
    makeTrackSwipeable(section);
  };

  // Apply now…
  apply();

  // …and keep enforcing if the theme re-injects arrows
  if (!drawer.dataset.po2NoArrowObserver) {
    const mo = new MutationObserver(() => apply());
    mo.observe(drawer, { childList: true, subtree: true, attributes: true });
    drawer.dataset.po2NoArrowObserver = '1';
  }
}

function moveUpsellAddNextToPrice() {
  if (window.innerWidth > 749) return;             // mobile only

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  // Scope strictly to "Complete the look!"
  const heading = Array.from(drawer.querySelectorAll('h1,h2,h3,h4'))
    .find(h => /complete\s*the\s*look/i.test(h.textContent || ''));
  if (!heading) return;

  const section = heading.closest(
    'section, .shopify-section, [class*="recommend"], .cart-drawer__recommendations, .product-recommendations, div'
  );
  if (!section) return;

  // helper: find a visible price element in a card
  const findPrice = (root) =>
    root.querySelector('.price, .price-item, .price__regular, [class*="price"]') ||
    Array.from(root.querySelectorAll('*')).find(n => /\$[0-9]/.test((n.textContent || '')));

  const imp = (el, k, v) => el && el.style.setProperty(k, v, 'important');

  // For each upsell card (never the cart lines)
  section.querySelectorAll('.grid__item, [data-product-id], .product-card, .card, li, article, .slide').forEach(card => {
    if (card.dataset.po2InlineAdd === '1') return;

    // the real quick-add button in the card
    const addBtn =
      card.querySelector('.quick-add__submit, button[name="add"], form[action*="/cart/add"] button');
    const priceEl = findPrice(card);

    if (!addBtn || !priceEl || !priceEl.parentElement) return;

    const row = priceEl.parentElement;

    // Lay out [ $price ]  [ + ]
    imp(row, 'display', 'flex');
    imp(row, 'align-items', 'center');
    imp(row, 'gap', '8px');

    // Move the existing button right after the price
    if (addBtn.parentElement !== row) {
      row.insertBefore(addBtn, priceEl.nextSibling);
    }

    // Make it a small circular "+" (visual only, click logic unchanged)
    imp(addBtn, 'width', '28px');
    imp(addBtn, 'height', '28px');
    imp(addBtn, 'min-width', '28px');
    imp(addBtn, 'padding', '0');
    imp(addBtn, 'border-radius', '9999px');
    imp(addBtn, 'display', 'inline-flex');
    imp(addBtn, 'align-items', 'center');
    imp(addBtn, 'justify-content', 'center');
    imp(addBtn, 'font-size', '0');                  // hide text
    // put a + glyph inside without changing form behavior
    if (!addBtn.dataset.po2Iconized) {
      const span = document.createElement('span');
      span.textContent = '+';
      span.style.fontSize = '18px';
      span.style.fontWeight = '700';
      addBtn.appendChild(span);
      addBtn.dataset.po2Iconized = '1';
    }

    card.dataset.po2InlineAdd = '1';
  });
}
// Mobile only: add a caret to the "Complete the look!" heading and collapse/expand the carousel.
function ensureUpsellCollapsible() {
  if (window.innerWidth > 749) return;   // mobile only

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  // Find the "Complete the look!" heading (tolerant to spacing/case)
  const heading = Array.from(drawer.querySelectorAll('h1,h2,h3,h4'))
    .find(h => /complete\s*the\s*look/i.test((h.textContent || '')));
  if (!heading) return;

  // The section wrapper we’ll toggle the class on
  const section = heading.closest(
    'section, .shopify-section, [class*="recommend"], .cart-drawer__recommendations, .product-recommendations, div'
  );
  if (!section || section.dataset.po2Collapsible === '1') return;

  // Find the body (the slider/grid with the cards) we’ll hide/show
  let body =
    section.querySelector('.slider, [data-slider], .grid, [class*="grid"], .product-recommendations, .cart-drawer__recommendations');

  if (!body) {
    // Fallback: first sibling after the heading that contains product cards
    body = Array.from(section.children).find(el =>
      el !== heading && el.querySelector('.grid__item, [data-product-id], .product-card, .card, .slide')
    ) || heading.nextElementSibling;
  }
  if (!body) return;

  // Mark nodes so CSS can target safely
  body.setAttribute('data-po2-upsell-body', '1');
  heading.classList.add('po2-upsell-title');

  // Add a small caret button on the right side of the heading
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'po2-upsell-toggle';
  btn.setAttribute('aria-expanded', 'true');
  btn.innerHTML =
  '<svg class="po2-caret" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">' +
  '<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg>';

  heading.appendChild(btn);

  // Toggle collapsed state on the section
  btn.addEventListener('click', () => {
    const collapsed = section.classList.toggle('po2-upsell-collapsed');
    btn.setAttribute('aria-expanded', String(!collapsed));
  });

  section.dataset.po2Collapsible = '1';
}

/* === PO2 | Bundle price display in Cart Drawer "Complete the look!" === */
// Set to true to re-enable bundle discount pricing in the upsell carousel.
// (On window so the desktop runner further down can read the same switch.)
window.PO2_BUNDLE_PRICING_ENABLED = false;

function applyBundlePricingToUpsells() {
  if (!window.PO2_BUNDLE_PRICING_ENABLED) return;

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const upsellSection = drawer.querySelector('.cart-drawer__upsell');
  if (!upsellSection) return;

  // --- helpers ---
  const parseMoney = (txt) => {
    if (!txt) return null;
    const m = String(txt).match(/\$[0-9][\d,]*(?:\.\d{2})?/);
    if (!m) return null;
    return Number(m[0].replace(/[$,]/g, ''));
  };

  const formatMoney = (n) => {
    const v = Math.max(0, Number(n || 0));
    return `$${v.toFixed(2)}`;
  };

  const classify = (text) => {
    const t = (text || '').toUpperCase();
    if (/\b(HAT|CAP|BEANIE|5-PANEL|5 PANEL)\b/.test(t)) return 'hat';
    if (/\b(HOODIE|CREWNECK|SWEATSHIRT)\b/.test(t)) return 'hoodie';
    if (/\b(TEE|T-SHIRT|TSHIRT|LONG SLEEVE)\b/.test(t)) return 'tee';
    return null;
  };

  // Get cart state (what's currently in the drawer)
  const getCartState = () => {
    const items = Array.from(drawer.querySelectorAll('.cart-item'));
    let hatCount = 0, teeCount = 0, hoodieCount = 0;

    items.forEach((item) => {
      const titleEl =
        item.querySelector('.cart-item__name') ||
        item.querySelector('a[href*="/products/"]') ||
        item.querySelector('.cart-item__details') ||
        item;

      const title = (titleEl?.textContent || '').trim();
      const type = classify(title);

      const qtyInput =
        item.querySelector('quantity-input input') ||
        item.querySelector('.quantity__input') ||
        item.querySelector('input[name="updates[]"]');

      const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      if (type === 'hat') hatCount += qty;
      if (type === 'tee') teeCount += qty;
      if (type === 'hoodie') hoodieCount += qty;
    });

    return {
      hatCount,
      teeCount,
      hoodieCount,
      hasHat: hatCount > 0,
      hasTee: teeCount > 0,
      hasHoodie: hoodieCount > 0
    };
  };

  const cart = getCartState();

  // If cart is empty, restore any modified upsell prices and exit
  if (!(cart.hasHat || cart.hasTee || cart.hasHoodie)) {
    upsellSection.querySelectorAll('.upsell-item').forEach((card) => {
      const priceEl = card.querySelector('.upsell-price');
      if (!priceEl) return;
      if (card.dataset.po2OrigPriceText) {
        priceEl.textContent = card.dataset.po2OrigPriceText;
        delete card.dataset.po2OrigPriceText;
      }
      card.classList.remove('po2-bundle-active');
    });
    return;
  }

  // ==========================
  // PO2 BUNDLE DISCOUNT CONFIG
  // Edit these numbers only.
  // ==========================
  const PO2_BUNDLE_DISCOUNTS = {
    HAT_2ND_HAT: 5,      // Buy 2 Hats → Save $5 (discount applies to the upsell hat)
    HAT_PLUS_TEE: 6,     // Buy hat + Tee → Save $6
    HAT_PLUS_HOODIE: 8,  // Buy hat + Hoodie → Save $8
  };

  // Which discount applies to an upsell item, given what's already in the cart.
  // Note: This is display logic for the upsell cards (not Shopify’s real discount engine).
  const discountForTypeIfAdded = (type) => {
    // Hat upsell: show "2 hats" discount only if the cart already has at least 1 hat
    if (type === 'hat' && cart.hatCount >= 1) return PO2_BUNDLE_DISCOUNTS.HAT_2ND_HAT;

    // Tee upsell: discount if cart already has a hat
    if (type === 'tee' && cart.hasHat) return PO2_BUNDLE_DISCOUNTS.HAT_PLUS_TEE;

    // Hat upsell: discount if cart already has a tee
    if (type === 'hat' && cart.hasTee) return PO2_BUNDLE_DISCOUNTS.HAT_PLUS_TEE;

    // Hoodie upsell: discount if cart already has a hat
    if (type === 'hoodie' && cart.hasHat) return PO2_BUNDLE_DISCOUNTS.HAT_PLUS_HOODIE;

    // Hat upsell: discount if cart already has a hoodie
    if (type === 'hat' && cart.hasHoodie) return PO2_BUNDLE_DISCOUNTS.HAT_PLUS_HOODIE;

    return 0;
  };
  // --- PO2: SORT "Complete the look" cards ---
  // Sort order:
  // 1) eligible items first
  // 2) price high -> low
  // 3) within eligible, also high -> low (same rule)
  const sortUpsellCards = () => {
    const cards = Array.from(upsellSection.querySelectorAll('.upsell-item'));
    if (cards.length < 2) return;

    // Use the original price whenever possible (before we inject was/now HTML)
    const getOriginalPrice = (card) => {
      const priceEl = card.querySelector('.upsell-price');
      if (!priceEl) return -1;

      // If we've already stored the original, use it (most reliable)
      if (card.dataset.po2OrigPriceText) {
        const p = parseMoney(card.dataset.po2OrigPriceText);
        return p == null ? -1 : p;
      }

      // Otherwise parse whatever is currently in the price element
      const p = parseMoney(priceEl.textContent);
      return p == null ? -1 : p;
    };

    const getType = (card) => {
      const titleEl = card.querySelector('.upsell-title');
      const title = (titleEl?.textContent || '').trim();
      return classify(title);
    };

    const isEligible = (card) => {
      const type = getType(card);
      if (!type) return false;
      return discountForTypeIfAdded(type) > 0;
    };

    // Keep stable ordering for true ties
    const withIndex = cards.map((card, idx) => ({
      card,
      idx,
      eligible: isEligible(card),
      price: getOriginalPrice(card),
    }));

    withIndex.sort((a, b) => {
      // 1) eligible first
      if (a.eligible !== b.eligible) return a.eligible ? -1 : 1;

      // 2) price high -> low
      if (a.price !== b.price) return (b.price - a.price);

      // 3) stable fallback
      return a.idx - b.idx;
    });

    const parent = cards[0].parentElement;
    if (!parent) return;

    withIndex.forEach(({ card }) => parent.appendChild(card));
  };
  // Loop upsell cards
  upsellSection.querySelectorAll('.upsell-item').forEach((card) => {
    const titleEl = card.querySelector('.upsell-title');
    const priceEl = card.querySelector('.upsell-price');
    if (!titleEl || !priceEl) return;

    const titleText = (titleEl.textContent || '').trim();
    const type = classify(titleText);

    const rawPrice = parseMoney(priceEl.textContent);
    if (!type || rawPrice == null) return;

    const discount = discountForTypeIfAdded(type);

    // No discount applies: restore
    if (!discount) {
      if (card.dataset.po2OrigPriceText) {
        priceEl.textContent = card.dataset.po2OrigPriceText;
        delete card.dataset.po2OrigPriceText;
      }
      card.classList.remove('po2-bundle-active');
      return;
    }

    // Apply discount display
    if (!card.dataset.po2OrigPriceText) {
      card.dataset.po2OrigPriceText = priceEl.textContent.trim();
    }

    const newPrice = rawPrice - discount;

    // Use inline HTML inside the same .upsell-price block
    priceEl.innerHTML = `
      <span class="po2-was" style="text-decoration:line-through; opacity:.6; margin-right:6px;">
        ${formatMoney(rawPrice)}
      </span>
      <span class="po2-now" style="font-weight:700;">
        ${formatMoney(newPrice)}
      </span>
      <div class="po2-note" style="font-size:12px; opacity:.75; margin-top:2px;">
        Bundle discount!
      </div>
    `;

    card.classList.add('po2-bundle-active');
  });
    sortUpsellCards();
}
// expose for desktop runner (no behavior change by itself)
window.po2ApplyBundlePricingToUpsells = applyBundlePricingToUpsells;

function run() {
  if (!isMobile()) return;

  const d = document.getElementById('CartDrawer');
  if (!d) return;

  d.querySelectorAll('.cart-item').forEach(apply);
  toggleUpsellIfEmpty();
  hideUpsellArrowsOnMobile();
  ensureUpsellCollapsible();
  applyBundlePricingToUpsells();
}

  const tick = (()=>{let t; return ()=>{ clearTimeout(t); t=setTimeout(()=>{ run(); setTimeout(run,80); setTimeout(run,400); }, 20); };})();
  document.addEventListener('DOMContentLoaded', tick);
  document.addEventListener('cart:updated', tick);
  document.addEventListener('cart-drawer:updated', tick);
  window.addEventListener('resize', tick);
  const root = document.getElementById('CartDrawer');
  if (root) new MutationObserver(tick).observe(root, { childList:true, subtree:true });
})();

/* === PO2 | DESKTOP — apply bundle price display in Cart Drawer upsells === */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  // Feature switch lives near applyBundlePricingToUpsells above. When it's off,
  // skip wiring the observer/timers entirely instead of churning on every DOM change.
  if (!window.PO2_BUNDLE_PRICING_ENABLED) return;
  const isDesktop = () => window.innerWidth >= 750;

  const apply = () => {
    if (!isDesktop()) return;
    if (typeof window.po2ApplyBundlePricingToUpsells !== 'function') return;
    window.po2ApplyBundlePricingToUpsells();
  };

  // debounce so we run once after re-render waves
  const tick = (() => {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(() => {
        apply();
        setTimeout(apply, 80);
        setTimeout(apply, 300);
      }, 20);
    };
  })();

  document.addEventListener('DOMContentLoaded', tick);
  document.addEventListener('cart:updated', tick);
  document.addEventListener('cart-drawer:updated', tick);
  window.addEventListener('resize', tick);

  // watch the CartDrawer for DOM swaps
  const root = document.getElementById('CartDrawer');
  if (root) new MutationObserver(tick).observe(root, { childList: true, subtree: true });
})();

/* === PO2 | DESKTOP ONLY — revive upsell arrows in Cart Drawer === */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const MQ = window.matchMedia('(min-width: 750px)');
  const ARROW_SEL = '#CartDrawer .upsell-carousel > .carousel-arrow';

  function forceOnDesktop(el) {
    // Only override the props that were used to hide them
    el.style.setProperty('display', 'flex', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('pointer-events', 'auto', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('z-index', '1001', 'important'); // above contents

    // Mark as processed — the parent CartDrawer observer (below) will re-call
    // forceOnDesktop whenever the drawer re-renders, so we don't need a
    // per-element observer here (those multiply and cause customizer freezes).
    el.dataset.po2DesktopArrowGuard = '1';
  }

  function enableDesktopArrows() {
    if (!MQ.matches) return;                 // <-- never runs on mobile
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const arrows = drawer.querySelectorAll(ARROW_SEL);
    arrows.forEach(forceOnDesktop);
  }

  // If theme didn’t wire arrow clicks, make them scroll on desktop
  function handleArrowClick(e) {
    if (!MQ.matches) return;                 // desktop only
    const arrow = e.target.closest(ARROW_SEL);
    if (!arrow) return;
    const wrap = arrow.closest('.upsell-carousel');
    const track =
      wrap?.querySelector('.upsell-items') ||
      wrap?.querySelector('[data-slider], [class*="slider"], [class*="track"], ul, ol');
    if (!track) return;

    const dir = arrow.classList.contains('left') ? -1 : 1;
    const step = Math.max(200, Math.floor(track.clientWidth * 0.9));
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  // Run after DOM changes so we "win the race" against any hiders
  const queue = () => setTimeout(enableDesktopArrows, 0);

  document.addEventListener('DOMContentLoaded', queue);
  document.addEventListener('click', (ev) => {
    // when the drawer opens, re-apply on next tick
    if (ev.target.closest('.header__icon--cart,[data-cart-toggle],a[href$="/cart"]')) queue();
  });
  MQ.addEventListener('change', queue);

  // Watch only the cart drawer for updates and re-apply (desktop only)
  const bootObserver = () => {
    const node = document.getElementById('CartDrawer');
    if (!node || node.dataset.po2DesktopArrowObserver) return;
    const mo = new MutationObserver(queue);
    mo.observe(node, { childList: true, subtree: true });
    node.dataset.po2DesktopArrowObserver = '1';
  };
  document.addEventListener('DOMContentLoaded', bootObserver);
  document.addEventListener('click', (ev) => {
    if (ev.target.closest('.header__icon--cart,[data-cart-toggle],a[href$="/cart"]')) {
      setTimeout(bootObserver, 50);
    }
  });

  // Click handler for the arrows (desktop only, doesn’t affect mobile)
  document.addEventListener('click', handleArrowClick, true);
})();




/* PO2 — Mobile drawer state sync — single source of truth (layout-safe) */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__po2DrawerSyncBound) return;
  window.__po2DrawerSyncBound = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var savedY = 0;

  function lockBody() {
    if (!mq.matches) return;
    if (document.body.classList.contains('po2-lock')) return;

    savedY = window.scrollY || window.pageYOffset || 0;

    document.documentElement.style.setProperty('--po2-top', (-savedY) + 'px');
    document.documentElement.classList.add('po2-lock');
    document.body.classList.add('po2-lock');
  }

  function unlockBody() {
    if (!mq.matches) return;

    document.documentElement.classList.remove('po2-lock');
    document.body.classList.remove('po2-lock');
    document.documentElement.style.removeProperty('--po2-top');

    var y = (typeof savedY === 'number' && isFinite(savedY)) ? savedY : 0;
    savedY = 0;

    if (y) window.scrollTo(0, y);
  }

  function killOverlaysAndUndim() {
    var selectors = [
      '#CartDrawer-Overlay',
      '.cart-drawer__overlay',
      '.drawer__overlay',
      '.drawer__overlay-background',
      '.modal-overlay',
      '.modal__overlay'
    ];

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.opacity = '0';
        el.style.visibility = 'hidden';
        el.style.pointerEvents = 'none';
        el.style.display = 'none';
      });
    });

    // Remove any accidental dim styles
    document.querySelectorAll('body, #MainContent, .content-for-layout').forEach(function (el) {
      el.style.opacity = '';
      el.style.filter = '';
      el.style.webkitFilter = '';
    });
  }

  function closeAnyOpenDetailsInsideDrawer(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll('details[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  }

  function forceClose() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    drawer.classList.remove('active', 'is-open', 'open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.removeAttribute('open');

    closeAnyOpenDetailsInsideDrawer(drawer);

    document.documentElement.classList.remove('po2-drawer-open');
    unlockBody();
    killOverlaysAndUndim();
  }

  function isDrawerOpen(drawer) {
    if (!drawer) return false;

    // Dawn drawer is reliably open when it has "active".
    if (drawer.classList.contains('active')) return true;

    // Some builds use a <details open> internally.
    if (drawer.querySelector('details[open]')) return true;

    return false;
  }

  function sync() {
    if (!mq.matches) {
      document.documentElement.classList.remove('po2-drawer-open');
      unlockBody();
      killOverlaysAndUndim();
      return;
    }

    var drawer = document.getElementById('CartDrawer');
    var open = isDrawerOpen(drawer);

    document.documentElement.classList.toggle('po2-drawer-open', open);

    if (open) {
      lockBody();
    } else {
      unlockBody();
      killOverlaysAndUndim();
    }
  }

  // Close triggers (overlay, close button, escape)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setTimeout(forceClose, 0);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;

    // Clicking backdrop or close button
    if (t.closest('#CartDrawer-Overlay, .cart-drawer__overlay, .drawer__overlay, .drawer__close, button[aria-label="Close"]')) {
      setTimeout(forceClose, 0);
      return;
    }

    // Click outside inner drawer while open
    var drawer = document.getElementById('CartDrawer');
    if (drawer && document.documentElement.classList.contains('po2-drawer-open')) {
      var inner = drawer.querySelector('.drawer__inner');
      if (inner && !inner.contains(t) && drawer.contains(t)) {
        setTimeout(forceClose, 0);
      }
    }
  }, true);

  // Observe drawer changes
  var mo = new MutationObserver(function () { requestAnimationFrame(sync); });

  function observeDrawerWhenReady() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;

    mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'open', 'style'] });
    mo.observe(drawer, { childList: true, subtree: true });
    sync();
    return true;
  }

  if (!observeDrawerWhenReady()) {
    // Only watch direct children of body so we catch when CartDrawer is injected,
    // without paying the cost of subtree:true on the entire document.
    var boot = new MutationObserver(function () {
      if (observeDrawerWhenReady()) boot.disconnect();
    });
    boot.observe(document.body, { childList: true });
  }

  window.addEventListener('resize', function () { sync(); }, { passive: true });
  window.addEventListener('pageshow', function () { setTimeout(sync, 50); });

  setTimeout(sync, 0);
})();




/* PO2 – Close stray header <details> when the cart finishes closing */
(() => {
  const d = document.getElementById('CartDrawer');
  if (!d) return;

const closeHeaderDetails = () => {
  document.querySelectorAll('details[open]').forEach(el => el.removeAttribute('open'));
};


  // After the slide-out animation completes
  d.addEventListener('transitionend', (e) => {
    if (e.propertyName !== 'transform') return;
    // Drawer off-canvas? treat as closed and clean up.
    const r = d.getBoundingClientRect();
    if (r.left >= window.innerWidth || r.right <= 0) closeHeaderDetails();
  });

  // Also when tapping overlay or any drawer-close control
  document.addEventListener('click', (e) => {
    if (e.target.closest('#CartDrawer-Overlay,[data-drawer-close]')) {
      setTimeout(closeHeaderDetails, 200);
    }
  });
})();
/* PO2 — Desktop: toggle upsell visibility based on empty state */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  const drawer = () => document.getElementById('CartDrawer');
  const itemsEl = () => drawer()?.querySelector('cart-drawer-items');
  const upsellEl = () => drawer()?.querySelector('.cart-drawer__upsell');

  function applyUpsellState() {
    if (!isDesktop()) return;                 // do NOT touch mobile/tablet
    const items = itemsEl(), upsell = upsellEl();
    if (!items || !upsell) return;
    const empty = items.classList.contains('is-empty');
    upsell.style.setProperty('display', empty ? 'none' : '', 'important');
  }

  // Run on load, on resize (desktop only), and whenever the class changes
  document.addEventListener('DOMContentLoaded', () => {
    applyUpsellState();
    const items = itemsEl();
    if (items) {
      new MutationObserver(applyUpsellState)
        .observe(items, { attributes: true, attributeFilter: ['class'] });
    }
  });
  window.addEventListener('resize', applyUpsellState);

  // Also re-check right after opening the drawer
  document.addEventListener('click', (e) => {
    if (e.target.closest('.header__icon--cart,[data-cart-toggle],a[href$="/cart"]')) {
      setTimeout(applyUpsellState, 80);
    }
  });
})();


/* Piste Out — make "Buy with Shop Pay" a rectangle ONLY */
(() => {
  // Skip in the theme customizer — observing document.body with subtree:true
  // floods the customizer iframe with events and causes section-add freezes.
  if (window.Shopify && window.Shopify.designMode) return;

  const RADIUS = '0px'; // change to '12px' if you want slightly rounded corners

  function squareShopPay() {
    document.querySelectorAll('shop-pay-wallet-button').forEach((el) => {
      const root = el.shadowRoot;
      if (!root) return;

      // Set component var (some builds honor this)
      el.style.setProperty('--gravity-button-border-radius', RADIUS);

      // Force the actual internal button to be rectangular
      const styleTag = root.getElementById('po-rect-style') || document.createElement('style');
      styleTag.id = 'po-rect-style';
      styleTag.textContent = `
        .accelerated-checkout-button { border-radius: ${RADIUS} !important; overflow: hidden !important; }
        .gravity-button { border-radius: ${RADIUS} !important; clip-path: inset(0 round ${RADIUS}) !important; }
      `;
      if (!styleTag.parentNode) root.appendChild(styleTag);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', squareShopPay);
  } else {
    squareShopPay();
  }
  document.addEventListener('shopify:section:load', squareShopPay);

  // Scope to the checkout/cart area only — not all of document.body
  const scope = document.querySelector('.shopify-payment-button, #CartDrawer, #cart, .cart') || document.body;
  new MutationObserver(squareShopPay).observe(scope, { childList: true, subtree: true });
})();
/* PO2 — DESKTOP cart drawer: align thumbnail to title + move qty/total/trash up 20px (desktop only) */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const MQ = window.matchMedia('(min-width: 750px)');
  const DRAWER_ID = 'CartDrawer';

  const qs = (root, sel) => root ? root.querySelector(sel) : null;

  function fixRow(row) {
    if (!MQ.matches) return;

    // 1) Align row content to the top so thumbnail top matches title
    row.style.setProperty('align-items', 'flex-start', 'important');

    const media = qs(row, '.cart-item__media');
    if (media) media.style.setProperty('align-self', 'flex-start', 'important');

    const details = qs(row, '.cart-item__details');
    if (details) {
      details.style.setProperty('padding-top', '0', 'important');
      details.style.setProperty('margin-top', '0', 'important');
    }

    // 2) Build a single "pack" that moves together (qty + trash on one line, total below)
    const qtyCell =
      qs(row, 'td[headers="CartDrawer-ColumnQuantity"]') ||
      qs(row, 'td.cart-item__quantity');

    if (!qtyCell) return;

    const qty =
      qs(qtyCell, 'quantity-input') ||
      qs(qtyCell, '.quantity');

    const remove =
      qs(qtyCell, 'cart-remove-button') ||
      qs(qtyCell, '.cart-remove') ||
      qs(qtyCell, '.cart-remove-button') ||
      qs(qtyCell, '[data-cart-remove]') ||
      qs(qtyCell, 'button[name="remove"]') ||
      qs(qtyCell, 'a[href*="change?"][href*="quantity=0"]');

    const total =
      qs(qtyCell, '.cart-item__totals') ||
      qs(qtyCell, '.cart-item__total-line') ||
      qs(qtyCell, '[class*="totals"]');

    if (!qty) return;

    // Create wrapper once
    let pack = qs(qtyCell, '.po2-desktop-qty-pack');
    if (!pack) {
      pack = document.createElement('div');
      pack.className = 'po2-desktop-qty-pack';
      qtyCell.appendChild(pack);

      qtyCell.style.setProperty('text-align', 'right', 'important');
qtyCell.style.setProperty('padding-right', '0', 'important');
qtyCell.style.setProperty('padding-top', '0', 'important');

      pack.style.setProperty('position', 'relative', 'important');
      pack.style.setProperty('top', '-34px', 'important');  // move selector/total/trash UP more
pack.style.setProperty('margin-left', 'auto', 'important');
pack.style.setProperty('width', 'auto', 'important');
      pack.style.setProperty('display', 'flex', 'important');
      pack.style.setProperty('flex-direction', 'column', 'important');
      pack.style.setProperty('align-items', 'center', 'important');
      pack.style.setProperty('gap', '14px', 'important'); // space between row + TOTAL
      pack.style.setProperty('width', '100%', 'important');
    }

    let topRow = qs(pack, '.po2-desktop-qty-top');
    if (!topRow) {
      topRow = document.createElement('div');
      topRow.className = 'po2-desktop-qty-top';
      pack.appendChild(topRow);

      topRow.style.setProperty('display', 'inline-flex', 'important');
      topRow.style.setProperty('align-items', 'center', 'important');
      topRow.style.setProperty('justify-content', 'center', 'important');
      topRow.style.setProperty('gap', '12px', 'important');
    }

    // Move qty + remove into topRow
    if (qty.parentElement !== topRow) topRow.appendChild(qty);
    if (remove && remove.parentElement !== topRow) topRow.appendChild(remove);

    // Move TOTAL under it (still inside the same pack)
    if (total && total.parentElement !== pack) pack.appendChild(total);
  }

  function run() {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;

    // Cart drawer line items are typically tr.cart-item
    drawer.querySelectorAll('tr.cart-item, .cart-item').forEach((row) => {
      // only operate on real cart rows (avoid upsell cards that reuse .cart-item sometimes)
      if (!row.closest('#' + DRAWER_ID)) return;
      if (!row.querySelector('.cart-item__media')) return;
      fixRow(row);
    });
  }

  function boot() {
    run();
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    if (drawer.dataset.po2DesktopQtyPackObserver) return;

    new MutationObserver(() => requestAnimationFrame(run))
      .observe(drawer, { childList: true, subtree: true, attributes: true });

    drawer.dataset.po2DesktopQtyPackObserver = '1';
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('resize', () => { if (MQ.matches) run(); });
})();


/* === PO2 | iOS Safari Cart Drawer Anti-Bounce v2 (dynamic scroller) === */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const MOBILE = '(max-width: 749px)';
  const DRAWER_SEL = '#CartDrawer';

  const isMobile = () => window.matchMedia(MOBILE).matches;

  const isiOS = () =>
    /iP(ad|hone|od)/.test(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

  const drawerEl = () => document.querySelector(DRAWER_SEL);

  const isDrawerOpen = () => {
    const d = drawerEl();
    if (!d) return false;
    return (
        d.classList.contains('active') ||
  d.hasAttribute('open') ||
  d.getAttribute('aria-hidden') === 'false'

    );
  };

  // Find the *actual* scroll container for the current touch target
  function closestScrollable(start, drawer) {
    let el = start;
    while (el && el !== drawer && el.nodeType === 1) {
      const cs = window.getComputedStyle(el);
      const oy = cs.overflowY;
      const canScrollY =
        (oy === 'auto' || oy === 'scroll') &&
        el.scrollHeight > el.clientHeight + 1;

      if (canScrollY) return el;
      el = el.parentElement;
    }

    // Fallback: first scrollable inside drawer
    const fallback = drawer.querySelectorAll('*');
    for (const node of fallback) {
      if (!(node instanceof HTMLElement)) continue;
      const cs = window.getComputedStyle(node);
      const oy = cs.overflowY;
      const canScrollY =
        (oy === 'auto' || oy === 'scroll') &&
        node.scrollHeight > node.clientHeight + 1;

      if (canScrollY) return node;
    }
    return null;
  }

  let startY = 0;
  let activeScroller = null;

  function shouldRun() {
    return isiOS() && isMobile() && isDrawerOpen();
  }

  document.addEventListener(
    'touchstart',
    (e) => {
      if (!shouldRun()) return;

      const drawer = drawerEl();
      if (!drawer) return;

      // Ensure drawer itself does not chain scroll when supported
      try { drawer.style.setProperty('overscroll-behavior', 'contain'); } catch (err) {}

      const insideDrawer = e.target && e.target.closest && e.target.closest(DRAWER_SEL);
      if (!insideDrawer) return;

      activeScroller = closestScrollable(e.target, drawer);
      startY = e.touches ? e.touches[0].clientY : 0;
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchmove',
    (e) => {
      if (!shouldRun()) return;

      const drawer = drawerEl();
      if (!drawer) return;

      const insideDrawer = e.target && e.target.closest && e.target.closest(DRAWER_SEL);

      // If the drawer is open and the touch is outside it, block page scroll completely
      if (!insideDrawer) {
        e.preventDefault();
        return;
      }

      // If we couldn't find a scroller, block (better to block than bounce)
      if (!activeScroller) {
        e.preventDefault();
        return;
      }

      const y = e.touches ? e.touches[0].clientY : 0;
      const dy = y - startY;

      const atTop = activeScroller.scrollTop <= 0;
      const atBottom =
        activeScroller.scrollTop + activeScroller.clientHeight >= activeScroller.scrollHeight - 1;

      // Only prevent at boundaries (this is the rubber-band moment)
      if ((atTop && dy > 0) || (atBottom && dy < 0)) {
        e.preventDefault();
      }
    },
    { passive: false, capture: true }
  );
})();
/* PO2 | Cart close overlay failsafe (does not touch iOS bounce logic) */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__po_cart_overlay_failsafe__) return;
  window.__po_cart_overlay_failsafe__ = true;

  const mq = window.matchMedia('(max-width: 749px)');
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function hideEl(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
  }

  function clearDimming() {
    [document.body, qs('#MainContent'), qs('.content-for-layout')]
      .filter(Boolean)
      .forEach((el) => {
        el.style.removeProperty('opacity');
        el.style.removeProperty('filter');
        el.style.removeProperty('backdrop-filter');
      });
  }

  function closeHeaderStuff() {
    // Close any stuck drawer/modals driven by <details open>
    qsa('header-drawer details[open], menu-drawer details[open], details-modal details[open]').forEach((d) =>
      d.removeAttribute('open')
    );

    // Reset the header menu overlay pseudo-state
    qsa('.header__icon--menu[aria-expanded="true"]').forEach((btn) =>
      btn.setAttribute('aria-expanded', 'false')
    );
  }

  function drawerLooksClosed(drawer) {
    if (!drawer) return true;
    const r = drawer.getBoundingClientRect();
    return r.left >= window.innerWidth - 1 || r.right <= 1;
  }

  function cleanupIfClosed() {
    if (!mq.matches) return;

    const drawer = qs('#CartDrawer');

    // Only clean up when the cart is actually closed/off-canvas
    const isReallyClosed =
      drawerLooksClosed(drawer) ||
      (drawer &&
        !drawer.classList.contains('active') &&
        drawer.getAttribute('aria-hidden') !== 'false' &&
        !drawer.hasAttribute('open'));

    if (!isReallyClosed) return;

    // Remove the helper "open" class so your CSS undim rules apply
    document.documentElement.classList.remove('po2-drawer-open');

    // Hard-hide common overlay elements
    hideEl(qs('#CartDrawer-Overlay'));
    qsa('.cart-drawer__overlay, .drawer__overlay, .drawer__overlay-background, .modal-overlay').forEach(hideEl);

    clearDimming();
    closeHeaderStuff();
  }

  // Close-like interactions, run cleanup after theme handlers finish
  document.addEventListener(
    'click',
    (e) => {
      if (
        e.target.closest(
          '#CartDrawer-Overlay, .cart-drawer__close, [data-drawer-close], [aria-label="Close"]'
        )
      ) {
        setTimeout(cleanupIfClosed, 300);
      }
    },
    true
  );

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') setTimeout(cleanupIfClosed, 200);
  });

  document.addEventListener('DOMContentLoaded', () => {
    const d = qs('#CartDrawer');
    if (!d) return;
    d.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'transform') setTimeout(cleanupIfClosed, 0);
    });
  });

  window.addEventListener('pageshow', () => setTimeout(cleanupIfClosed, 0));
  setTimeout(cleanupIfClosed, 0);
})();
/* PO — iOS Safari: cleanup stuck cart overlay after drawer close (no bounce/scroll changes) */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const init = () => {
    const drawer = document.querySelector('cart-drawer.drawer');
    if (!drawer) return;

    const overlay =
      drawer.querySelector('#CartDrawer-Overlay') ||
      drawer.querySelector('.cart-drawer__overlay');

    if (!overlay) return;

    const applyClosed = () => {
      // Immediately make it non-interactive + invisible
      overlay.style.pointerEvents = 'none';
      overlay.style.visibility = 'hidden';
      overlay.style.opacity = '0';

      // After the close animation window, fully remove it from paint
      window.setTimeout(() => {
        if (!drawer.classList.contains('active') && !drawer.hasAttribute('open')) {
          overlay.style.display = 'none';
        }
      }, 250);
    };

    const applyOpen = () => {
      // Restore so CSS can animate normally
      overlay.style.display = '';
      overlay.style.pointerEvents = '';
      overlay.style.visibility = '';
      overlay.style.opacity = '';
    };

    const sync = () => {
      const isOpen = drawer.classList.contains('active') || drawer.hasAttribute('open');
      if (isOpen) applyOpen();
      else applyClosed();
    };

    // Watch only the drawer state changes
    const mo = new MutationObserver(sync);
    mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });

    // Run once on load
    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* NOTE: The old "unhide Judge.me badge" JS block was removed — the
   `.jdgm-prev-badge { display:inline-flex !important; ... }` CSS in
   layout/theme.liquid already forces the badge visible and overrides
   any inline `display:none`, so the extra MutationObserver was pure overhead. */

/* === PO2 | PDP Upsell — variant picker + add to cart + open drawer === */
(function () {
  if (window.__po2PdpUpsellBound) return;
  window.__po2PdpUpsellBound = true;

  function po2PdpAddToCart(variantId, btn) {
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function () {
        return fetch('/cart?section_id=cart-drawer');
      })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var newDrawerEl = parser.parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var cartDrawer = document.querySelector('#CartDrawer');

        if (cartDrawer && newDrawerEl) {
          cartDrawer.innerHTML = newDrawerEl.innerHTML;

          // Re-bind overlay close
          var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          var drawerCustomEl = document.querySelector('cart-drawer');
          if (overlay && drawerCustomEl) {
            overlay.addEventListener('click', drawerCustomEl.close.bind(drawerCustomEl));
          }
        }

        // Open the cart drawer
        var drawerCustomEl = document.querySelector('cart-drawer');
        if (drawerCustomEl && typeof drawerCustomEl.open === 'function') {
          drawerCustomEl.open();
        }

        btn.disabled = false;
        btn.textContent = '✓';
        setTimeout(function () {
          // Reset back only if the button is still showing the checkmark
          if (btn.textContent === '✓') btn.textContent = originalText;
        }, 1500);
      })
      .catch(function (err) {
        console.error('PO2 PDP upsell add failed:', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  document.addEventListener('click', function (e) {
    // Single-variant "Add" button — has data-variant-id, is NOT a --pick or --confirm
    var addBtn = e.target.closest('.po2-pdp-upsell__btn[data-variant-id]');
    if (addBtn) {
      e.preventDefault();
      po2PdpAddToCart(addBtn.dataset.variantId, addBtn);
      return;
    }

    // Multi-variant "Add" button — opens the inline picker
    var pickBtn = e.target.closest('.po2-pdp-upsell__btn--pick');
    if (pickBtn) {
      e.preventDefault();
      var row = pickBtn.closest('.po2-pdp-upsell__row');
      var picker = row && row.querySelector('.po2-pdp-upsell__picker');
      if (picker) {
        pickBtn.hidden = true;
        pickBtn.setAttribute('aria-expanded', 'true');
        picker.hidden = false;
        var select = picker.querySelector('.po2-pdp-upsell__select');
        if (select) select.focus();
      }
      return;
    }

    // Confirm button inside the variant picker
    var confirmBtn = e.target.closest('.po2-pdp-upsell__btn--confirm');
    if (confirmBtn) {
      e.preventDefault();
      var row = confirmBtn.closest('.po2-pdp-upsell__row');
      var select = row && row.querySelector('.po2-pdp-upsell__select');
      if (!select || !select.value) return;
      po2PdpAddToCart(select.value, confirmBtn);
      return;
    }
  });
})();